import { Inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@ridango/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationFacade } from '@ridango/components';
import Env from '@ridango/core/env';

@Injectable()
export class CompanyGuard implements CanActivate {
    constructor(
        public authService: AuthService,
        @Inject('ENV') public env: Env,
        public notifications: NotificationFacade,
        public router: Router,
        private translate: TranslateService
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        const companyId = this.authService.getLoggedInUserCompanyId();
        if (this.env.IS_CORPORATE && (!companyId || isNaN(parseInt(companyId, 10)))) {
            this.notifications.error(this.translate.instant('LOCAL_SELECT_COMPANY_TO_CONTINUE'));
            this.router.navigate([this.translate.currentLang, 'account', 'switch-company']);
            return false;
        }
        return true;
    }
}
